export default __webpack_public_path__ + "static/media/4.ef248a84.jpg";